/*
 * Lou's Merkliste (ohne App, ohne Konto).
 * Die Liste liegt nur im Browser (localStorage). Eintrag je Variante:
 *   { v: Varianten-ID, h: Produkt-Handle, p: Produkt-ID, t: Zeitpunkt }
 * Herzen: [data-lous-wish] mit data-variant / data-handle / data-product.
 * Header-Zaehler: [data-lous-wish-count] (Wrapper: [data-lous-wish-count-wrap]).
 * Merkliste-Seite: [data-lous-wishlist] holt je Eintrag die regulaere Produktkarte ueber
 *   /products/<handle>?view=wishcard&variant=<id>  (templates/product.wishcard.liquid).
 * GA4: Ereignis 'add_to_wishlist' beim Merken (nur mit Analytics-Zustimmung).
 * Klaviyo: Ereignis 'Added to Wishlist' beim Merken (Flow-Ausloeser) und nach jeder Aenderung ein identify mit
 *   den Profil-Eigenschaften 'Merkliste' (Varianten-IDs, neueste zuerst, max. 6) und 'Merkliste Anzahl'.
 * Merkliste-Link aus der Mail: /pages/merkliste?add=<handle>:<variantenId>,... fuegt die Eintraege (Union, ohne
 *   Dubletten, nichts wird ueberschrieben, hoechstens 12) in die lokale Liste ein und entfernt den Parameter. Kein
 *   'Added to Wishlist'-Ereignis dafuer, damit der Flow nicht erneut ausloest.
 * Warenkorb auf der Merkliste: echtes <form is="product-form"> des Themes, d. h. Impact legt in den
 * Warenkorb, aktualisiert und oeffnet den Cart-Drawer selbst (variant:add / cart:change).
 */
(function () {
  'use strict';
  if (window.__lousWishlist) return;
  window.__lousWishlist = true;

  var KEY = 'lous_wishlist';

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return x && x.v && x.h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    identify(list);
  }
  // Profil-Eigenschaften fuer die Merkliste-Mails: die Mail zeigt alle gemerkten Teile, nicht nur das aus dem
  // Ereignis. Neueste zuerst, hoechstens 6. Wirkt nur bei Profilen, die Klaviyo bereits kennt.
  function identify(list) {
    var k = window.klaviyo || (window.klaviyo = []);
    k.push(['identify', {
      'Merkliste': list.slice(0, 6).map(function (x) { return String(x.v); }),
      'Merkliste Anzahl': list.length
    }]);
  }
  function has(list, vid) {
    for (var i = 0; i < list.length; i++) if (String(list[i].v) === String(vid)) return true;
    return false;
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-lous-wish]').forEach(function (b) {
      var on = has(list, b.getAttribute('data-variant'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-lous-wish-count]').forEach(function (e) { e.textContent = list.length; });
    document.querySelectorAll('[data-lous-wish-count-wrap]').forEach(function (e) { e.hidden = !list.length; });
  }

  // Klaviyo Onsite-Ereignis fuer den Merkliste-Flow. Kommt nur bei Besuchern an, die Klaviyo kennt.
  function track(item) {
    fetch(root() + 'products/' + encodeURIComponent(item.h) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(item.v); })[0] || {};
        var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
        var k = window.klaviyo || (window.klaviyo = []);
        k.push(['track', 'Added to Wishlist', {
          ProductID: p.id,
          VariantID: v.id,
          ProductName: p.title,
          VariantName: v.public_title || '',
          Price: (v.price || p.price) / 100,
          CompareAtPrice: v.compare_at_price ? v.compare_at_price / 100 : null,
          URL: location.origin + p.url,
          ImageURL: img.indexOf('//') === 0 ? 'https:' + img : img,
          Available: !!v.available
        }]);
        // GA4: gtag gibt es nur nach Analytics-Zustimmung (Google & YouTube App), ohne Zustimmung kein Ereignis.
        // item_id im Format der App, damit das Ereignis zu view_item/add_to_cart passt.
        if (typeof window.gtag === 'function') {
          var price = (v.price || p.price) / 100;
          window.gtag('event', 'add_to_wishlist', {
            send_to: 'G-2EWFFS3XTT',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
            value: price,
            items: [{
              item_id: 'shopify_ZZ_' + p.id + '_' + v.id,
              item_name: p.title,
              item_variant: v.public_title || '',
              item_brand: p.vendor || '',
              price: price,
              quantity: 1
            }]
          });
        }
      })
      .catch(function () {});
  }

  function toggle(b) {
    var vid = b.getAttribute('data-variant'), h = b.getAttribute('data-handle');
    if (!vid || !h) return;
    var list = read();
    if (has(list, vid)) {
      list = list.filter(function (x) { return String(x.v) !== String(vid); });
    } else {
      var item = { v: String(vid), h: h, p: b.getAttribute('data-product') || '', t: Date.now() };
      list.unshift(item);
      track(item);
    }
    write(list);
    paint();
    if (b.closest('[data-lous-wishlist]')) renderPage();
  }

  function renderPage() {
    var box = document.querySelector('[data-lous-wishlist]');
    if (!box) return;
    var empty = document.querySelector('[data-lous-wishlist-empty]');
    var list = read();
    if (!list.length) {
      box.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (it) {
      return fetch(root() + 'products/' + encodeURIComponent(it.h) + '?view=wishcard&variant=' + encodeURIComponent(it.v))
        .then(function (r) { if (r.status === 404) return 'gone'; return r.ok ? r.text() : null; })
        .catch(function () { return null; })
        .then(function (html) {
          if (html === 'gone') { it.gone = true; return ''; }
          if (!html || html.indexOf('lous-wl-item') < 0) return '';
          // Unbekannte Variante: Shopify faellt auf die Standardvariante zurueck, dann gilt der Eintrag als weg.
          if (html.indexOf('data-wl-variant="' + it.v + '"') < 0) { it.gone = true; return ''; }
          return html;
        });
    })).then(function (cards) {
      // Geloeschte Produkte oder Varianten fliegen aus der Liste, sonst zaehlt der Header sie weiter mit.
      if (list.some(function (x) { return x.gone; })) {
        write(read().filter(function (x) {
          return !list.some(function (g) { return g.gone && String(g.v) === String(x.v); });
        }));
      }
      var html = cards.join('');
      box.innerHTML = html ? '<div class="product-list lous-wl-grid">' + html + '</div>' : '';
      if (empty) empty.hidden = !!html;
      paint();
    });
  }

  // Link aus der Mail: ?add=handle:variantId,... in die lokale Liste uebernehmen (nur auf der Merkliste-Seite).
  // Ungueltige Teile werden still verworfen, der Parameter verschwindet in jedem Fall aus der Adresse.
  function mergeFromUrl() {
    if (!document.querySelector('[data-lous-wishlist]')) return;
    var url;
    try { url = new URL(location.href); } catch (e) { return; }
    if (!url.searchParams.has('add')) return;
    var raw = url.searchParams.get('add') || '';
    url.searchParams.delete('add');
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) {}
    var list = read(), changed = false;
    raw.split(',').slice(0, 12).forEach(function (part) {
      var m = /^([a-z0-9-]+):(\d+)$/.exec(part.trim());
      if (!m || has(list, m[2])) return;
      list.push({ v: m[2], h: m[1], p: '', t: Date.now() });
      changed = true;
    });
    if (changed) write(list);
  }

  function init() {
    mergeFromUrl();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lous-wish]');
      if (b) { e.preventDefault(); e.stopPropagation(); toggle(b); }
    }, true);

    // PDP: Variantenwechsel. Impact rendert den Buy-Buttons-Block neu (data-variant kommt dann frisch vom
    // Server); zusaetzlich die ID sofort aus dem Ereignis setzen, falls der Neuaufbau ausbleibt.
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      var form = e.target && e.target.getAttribute && e.target.getAttribute('id');
      if (v && v.id && form) {
        document.querySelectorAll('[data-lous-wish][data-form="' + form + '"]').forEach(function (b) {
          b.setAttribute('data-variant', v.id);
        });
      }
      paint();
    });

    // Neu eingefuegte Herzen (Teil-Rerender der PDP, Filter, Quick-Buy, nachgeladene Karten) einfaerben.
    var scheduled = false;
    new MutationObserver(function (records) {
      if (scheduled) return;
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-lous-wish') || n.querySelector('[data-lous-wish]'))) {
            scheduled = true;
            requestAnimationFrame(function () { scheduled = false; paint(); });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Andere Tabs halten Zaehler und Herzen synchron.
    window.addEventListener('storage', function (e) { if (e.key === KEY) { paint(); renderPage(); } });

    paint();
    renderPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
